<template>
  <ElInputWrapper class="w-full">
    <FlexLayout align="center" :gap="8">
      <FlexLayout class="w-full" align="center" :gap="8">
        <!-- hidden file input for uploading logo -->
        <input
          ref="fileInput"
          type="file"
          accept="image/*"
          style="display: none"
          @change="onFileChange"
        >

        <div class="upload-logo-btn-wrapper">
          <div class="truncate" style="padding: 0 8px">
            <span class="truncate">{{ displayData.fileName || '未上傳' }}</span>
          </div>
          <BaseElButton
            v-if="!displayData.fileName"
            class="upload-logo-btn"
            style="width: 100%; max-width: 156px"
            @click="triggerFileInput"
          >
            <FlexLayout align="center" :gap="4">
              <MaterialIcon>upload</MaterialIcon>
              上傳 logo 圖檔
            </FlexLayout>
          </BaseElButton>

          <BaseElButton
            v-if="displayData.fileName"
            class="re-upload-logo-btn"
            @click="triggerFileInput"
          >
            重新上傳
          </BaseElButton>
        </div>
      </FlexLayout>
    </FlexLayout>
  </ElInputWrapper>
</template>

<script>
import ElInputWrapper from '@/components/ElInputWrapper.vue'
import { useVModel } from '@vueuse/core'
import { defineComponent, ref, onUnmounted, computed, reactive } from 'vue'
export default defineComponent({
  name: 'UploadFileWithFileNameButton',
  components: { ElInputWrapper },
  props: {
    value: {
      type: Object,
      default: () => ({ file: null }),
    },
    uploadFn: {
      type: Function,
      default: null,
    },
  },
  setup (props, { emit }) {
    const formData = useVModel(props, 'value', emit)
    const loading = reactive({
      upload: false,
    })
    const fileInput = ref(null)
    const previewUrl = ref(null)

    const displayData = computed(() => {
      return {
        fileName: formData.value.file ? formData.value.file.name : null,
      }
    })

    function triggerFileInput () {
      if (fileInput.value && fileInput.value.click) {
        fileInput.value.click()
      }
    }

    async function onFileChange (e) {
      if (loading.upload) return
      loading.upload = true
      const files = e.target.files
      if (!files || files.length === 0) return
      const file = files[0]

      // revoke previous preview if any
      if (previewUrl.value) {
        URL.revokeObjectURL(previewUrl.value)
        previewUrl.value = null
      }

      formData.value.file = file
      previewUrl.value = URL.createObjectURL(file)

      if (props.uploadFn) {
        const [res, errMsg] = await props.uploadFn(file)
        if (errMsg) {
          loading.upload = false
          window.$message.error(errMsg)
          return
        }
        emit('change', {
          uploaded: res,
          rawFile: file,
          previewUrl: previewUrl.value,
        })
      } else {
        emit('change', { rawFile: file, previewUrl: previewUrl.value })
      }
      loading.upload = false
    }

    function clearLogo () {
      formData.value.file = null
      if (previewUrl.value) {
        URL.revokeObjectURL(previewUrl.value)
        previewUrl.value = null
      }
      // clear native input value so same file can be selected again
      if (fileInput.value) fileInput.value.value = ''
      emit('change', { rawFile: null, previewUrl: null })
    }

    onUnmounted(() => {
      if (previewUrl.value) URL.revokeObjectURL(previewUrl.value)
    })

    return {
      displayData,
      formData,
      fileInput,
      previewUrl,
      triggerFileInput,
      onFileChange,
      clearLogo,
    }
  },

})
</script>

<style lang="postcss" scoped>
.upload-logo-btn {
  @apply flex justify-center items-center h-[36px];
  @applt flex-shrink-0;
  @apply text-normal text-info py-[4px] px-[22px];
  /* border: solid 1px var(--info) !important; */
  @apply border border-info bg-white;
}

.re-upload-logo-btn {
  @apply flex justify-center items-center h-[36px];
  @applt flex-shrink-0;
  @apply text-normal text-info py-[7px] px-[12px];
  @apply border border-info bg-white;
}

.upload-logo-btn:focus, .re-upload-logo-btn:focus {
  @apply text-info border border-info;
}

.upload-logo-btn:hover, .re-upload-logo-btn:hover {
  @apply bg-info text-white;
}

.upload-logo-btn-wrapper {
  @apply flex items-center justify-between;
  @apply w-full rounded-l-[4px];
  @apply bg-primary-10;
}
</style>
